// SUNDAY BATCH · agent E — PR 3 · rule 1 (one data source, Code Health Report V1 · B-1a): the "not applicable on a TB-only
// engagement" notice shown where a test reads journal lines (cut-off, fingerprints, monthly series, matching, SURL GL checks).
// Merged into lib/i18n.js translations (big-file rule: new strings in their own file). EN + AR.
export const I18N_SBE = {
  en: {
    sbe: {
      tbOnly: {
        title: "Not applicable on a TB-only engagement",
        body: "This engagement's data source is the trial balance. A trial balance has no journal lines, so this test does not run. Load the general ledger to run it.",
        analytics: "The totals and the balance flags come from the trial balance. The cut-off entries, customer concentration, monthly trend, Benford, duplicate, round-number, weekend, ageing and dormant-account tests need journal lines: not applicable.",
      },
    },
  },
  ar: {
    sbe: {
      tbOnly: {
        title: "غير منطبق على مهمة بميزان مراجعة فقط",
        body: "مصدر بيانات هذه المهمة هو ميزان المراجعة. ميزان المراجعة لا يحتوي على قيود يومية، لذلك لا يعمل هذا الاختبار. حمّل دفتر الأستاذ العام لتشغيله.",
        analytics: "الإجماليات وتنبيهات الأرصدة مأخوذة من ميزان المراجعة. اختبارات قيود القطع وتركّز العملاء والاتجاه الشهري وبنفورد والتكرار والأرقام المقرّبة وعطلات نهاية الأسبوع والأعمار والحسابات الراكدة تحتاج إلى قيود يومية: غير منطبقة.",
      },
    },
  },
};

export default I18N_SBE;
